/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Branch } from 'src/app/_model/branches';
import { IMSId } from 'src/app/_model/ims-object';

@Injectable()
export abstract class BranchesDaoService implements Resetable {
  public abstract saveBranches(branches: Branch[]): Promise<void>;
  public abstract createBranch(branch: Branch): Promise<Branch>;
  public abstract deleteLocalBranch(id: IMSId): Promise<void>;
  public abstract getBranches(): Promise<Branch[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
